/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dropdownItemOfintSchema } from './dropdownItemOfintSchema.ts';
import { optionalSelectOptionSchema } from './optionalSelectOptionSchema.ts';
import { roleEnumSchema } from './roleEnumSchema.ts';
import { societaDropdownItemSchema } from './societaDropdownItemSchema.ts';
import { z } from 'zod';

export const createEmployeeRequestSchema = z.object({
  password: z.coerce.string().min(1).max(500),
  id: z.coerce.number().int().nullable().nullish(),
  lastName: z.coerce.string().min(1).max(500),
  firstName: z.coerce.string().min(1).max(500),
  email: z.coerce.string().min(0).max(500).nullable().nullish(),
  phoneNumber: z.coerce.string().nullable().nullish(),
  username: z.coerce.string().min(1).max(500),
  timesheetDaysForward: z.coerce.number().int().nullable().nullish(),
  timesheetDaysBackward: z.coerce.number().int().nullable().nullish(),
  registrationNumber: z.coerce.string().min(0).max(500).nullable().nullish(),
  enabled: z.boolean(),
  hoursPerDay: z.coerce.number().int().nullable().nullish(),
  employeeType: z.lazy(() => roleEnumSchema),
  clients: z.array(z.lazy(() => dropdownItemOfintSchema)),
  societa: z.array(z.lazy(() => societaDropdownItemSchema)),
  defaultSocieta: z
    .lazy(() => optionalSelectOptionSchema)
    .optional()
    .nullable(),
  timesheetCanCreateProjects: z.boolean().nullable().nullish(),
  timesheetCanCreateCustomers: z.boolean().nullable().nullish(),
  timesheetCanViewUnconfirmedProjects: z.boolean().nullable().nullish(),
  timesheetCanViewUnconfirmedCustomers: z.boolean().nullable().nullish(),
  timesheetCanViewAllCustomers: z.boolean().nullable().nullish(),
});
